export const DependencyInjectId = {
    HttpClient: 'HttpClient',
    UserMapper: 'UserMapper',
    UserApi: 'UserApi',
    OrganizationMapper: 'OrganizationMapper',
    OrganizationApi: 'OrganizationApi',
    CourseMapper: 'CourseMapper',
    CourseApi: 'CourseApi',
    AssessmentMapper: 'AssessmentMapper',
    AssessmentApi: 'AssessmentApi',
    TrackMapper: 'TrackMapper',
    TrackApi: 'TrackApi',
    ContestMapper: 'ContestMapper',
    ContestApi: 'ContestApi',
    ProSkillManagerMapper: 'ProSkillManagerMapper',
    ProSkillManagerApi: 'ProSkillManagerApi',
    LearningMapper: 'LearningMapper',
    LearningApi: 'LearningApi',
    LevelAssessmentMapper: 'LevelAssessmentMapper',
    LevelAssessmentApi: 'LevelAssessmentApi',
    ProSkillAssureMapper: 'ProSkillAssureMapper',
    ProSkillAssureApi: 'ProSkillAssureApi',
    ContactMapper: 'ContactMapper',
    ContactApi: 'ContactApi',
    ProfileMapper: 'ProfileMapper',
    ProfileApi: 'ProfileApi',
    HomeMapper: 'HomeMapper',
    HomeApi: 'HomeApi',
    CreditMapper: 'CreditMapper',
    CreditApi: 'CreditApi',
    ReportMapper: 'ReportMapper',
    ReportApi: 'ReportApi',
    SubscriptionApi: 'SubscriptionApi',
    SubscriptionMapper: 'SubscriptionMapper',
    SurveyMapper: 'SurveyMapper',
    SurveyApi: 'SurveyApi'
};
